import axios from "axios";
import React, { useEffect, useState } from "react";

import StatStyle from "./stat.module.css";

function Stat() {
	const [stats, setStats] = useState([]);
	const [date, setDate] = useState(new Date().toISOString().slice(0, 7));

	console.log(stats);
	console.log(date);

	useEffect(() => {
		axios.get("/omega/stats").then((res) => {
			setStats(res.data.results);
		});
	}, []);

	const filtered = stats.filter((v) => v.date.includes(date));

	return (
		<div className={StatStyle["statWrap"]}>
			<input type="month" value={date} onChange={(e) => setDate(e.target.value)} />
			<table className={StatStyle["statTable"]}>
				<caption>
					<h2>일일접속자수</h2>
				</caption>
				<colgroup>
					<col width="40%" />
					<col width="60%" />
				</colgroup>
				<thead>
					<tr>
						<th>일자</th>
						<th>접속자수</th>
					</tr>
				</thead>
				<tbody>
					{filtered.length === 0 ? (
						<tr>
							<td colSpan={2}>데이터가 없습니다.</td>
						</tr>
					) : (
						filtered.map((v, i) => (
							<tr key={i}>
								<td>{v.date}</td>
								<td>{v.requestCount}</td>
							</tr>
						))
					)}
				</tbody>
			</table>
		</div>
	);
}

export default Stat;
